import { Update } from '@ngrx/entity';
import { createAction, props } from '@ngrx/store';
import { AnalysisResults, AppAccessLevel } from '@sleipai/sleip-models';

export const loadAnalysis = createAction('[Analysis] Load Analysis');

export const loadAnalysisById = createAction(
  '[Analysis] Load analysis by id form frirebase',
  props<{ id: string; isFlexion: boolean }>()
);

export const loadMultipleAnalysisResultsByIds = createAction(
  '[Analysis] Load analysis results by ids form frirebase',
  props<{ recordingIds: string[] }>()
);

export const loadAnalysisSuccess = createAction(
  '[Analysis] Load Analysis Result Success',
  props<{ data: any }>()
);

export const loadMultipleAnalysisResultsByIdsSuccess = createAction(
  '[Analysis] Load Analysis Results By Ids Success',
  props<{ analysisResults: AnalysisResults[] | Partial<AnalysisResults>[] }>()
);

export const loadAnalysisFailure = createAction(
  '[Analysis] Load Analysis Failure',
  props<{ error: any }>()
);

export const addSingleAnalysis = createAction(
  '[Analysis] Reducer - Add single analysis to store',
  props<{ analysis: AnalysisResults | Partial<AnalysisResults> }>()
);

export const activeStride = createAction(
  '[Analysis] Reducer - set active stride',
  props<{ id: any }>()
);

export const updateSingleAnalysis = createAction(
  '[Analysis] Reducer - Update single anlysis',
  props<{ update: Update<any> }>()
);

export const shareAnalysis = createAction(
  '[Analysis] Share Analysis',
  props<{ recordingIds: string[]; horseId: string; version?: string }>()
);

export const shareAnalysisSuccess = createAction(
  '[Analysis] Share Analysis Success Link',
  props<{ data: string }>()
);

export const generateAnalysisResultPDF = createAction(
  '[Analysis] Generate AnalysisResult PDF',
  props<{
    recordingIds: string[];
    horseId: string;
    userType: AppAccessLevel;
    timeZone: string;
  }>()
);

export const generateAnalysisResultPDFSuccess = createAction(
  '[Analysis] Generate AnalysisResult PDF Success',
  props<{ downloadUrl: string }>()
);

export const shareAnalysisFailure = createAction(
  '[Analysis] Share Analysis Failure',
  props<{ error: any }>()
);

export const resetShareAnalysisLink = createAction(
  '[Analysis] Reset Share Analysis Link'
);

export const cancelShareAnalysis = createAction(
  '[Analysis] Cancel Share Analysis'
);

export const enableAnalysisLoadingFlag = createAction(
  '[Analysis] Enable Analysis Loading Flag'
);

export const resetAnalysisLoadingFlag = createAction(
  '[Analysis] Reset Analysis Loading Flag'
);
